<template lang="pug">
  .type-table
    .content
      .e-table.table.table_static-last-child
        e-perfect-scrollbar(
          :emitTypes="['vue']"
          :config="{suppressScrollY: false, suppressScrollX: false}"
          class="real-table-scrollbar table__header-wrapper"
        )
          .table__row
            .table__head.table__col(v-for="(item, i) in visibleColumns")
              .sortable
                .sortable__text {{ meta.fields[item].label }}
                .sortable__arrows(v-if="meta.sort && meta.fields[item].sortable")
                  button.reset-btn.button.button_no-border.button_icon.button_arrow.sortable__up(:class="meta.sort[item] === 'asc' ? 'active' : ''" v-on:click.prevent="letSort(item, 'asc')")
                  button.reset-btn.button.button_no-border.button_icon.button_arrow.sortable__down(:class="meta.sort[item] === 'desc' ? 'active' : ''" v-on:click.prevent="letSort(item, 'desc')")

          .table__body-wrapper(v-if="Object.values(values).length")
            .table__body(v-if="Object.keys(values).length")
              type-row(v-for="(value, key) in values" :key="'type-' + key" :value="value" :name="key"  )
</template>

<script>
import TypeRow from '@/app/classifier/components/type-row'
export default {
  name: 'type-table',
  components: { TypeRow },
  props: {
    items: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    currentSort: '',
  }),
  computed: {
    values() {
      return this.items.data
    },
    meta() {
      return this.items._meta
    },
    visibleColumns() {
      let columnsarr = []
      for (let fName in this.meta.fields) {
        columnsarr.push(fName)
      }
      return columnsarr
    },
  },
  methods: {
    letSort(item, direct) {
      if (this.meta.sort) {
        let key = Object.keys(this.meta.sort)[0]
        if (key !== item) {
          key = item
        }
        if (direct === 'desc') key = `-${key}`
        let newRoute = {
          name: this.$route.name,
          params: Object.assign({}, this.$route.params || {}),
          query: Object.assign({}, this.$route.query || {}),
        }
        newRoute.query['sort'] = key
        this.$router.push(newRoute)
      }
    },
  },
}
</script>
